import React from "react";

/**
 * Shown when a user browses a vendor's personal store while their cart
 * already contains items from a different vendor.
 * The backend rejects mixed-vendor carts, so we surface this early.
 */
export default function CartMismatchModal({ storeName, onClear, onKeep }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
        <h2 className="text-lg font-bold text-gray-900">Cart has items from another store</h2>
        <p className="mt-2 text-sm text-gray-600">
          Your current cart has items from a different store. To shop at{" "}
          <span className="font-semibold text-rose-600">{storeName}</span>, you'll need to clear
          your existing cart first.
        </p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            onClick={onKeep}
            className="order-2 rounded-xl border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 sm:order-1"
          >
            Keep existing cart
          </button>
          <button
            onClick={onClear}
            className="order-1 rounded-xl bg-rose-600 px-4 py-2 text-sm font-semibold text-white hover:bg-rose-700 sm:order-2"
          >
            Clear cart &amp; browse {storeName}
          </button>
        </div>
      </div>
    </div>
  );
}
